import * as React from 'react'
import { connect } from 'react-redux'
import { Container, Label } from 'reactstrap';
import { ApplicationState } from '../../store'
import { Redirect } from 'react-router-dom';
import { IUser } from '../../store/interface';
import BlobUtil from '../../utils/blobUtil'
import FaceUtil from '../../utils/faceUtil'
import { ReactComponent as Loader } from './loader.svg';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge } 
    from 'reactstrap';
import CameraFaceDetect from '../../components/Face/cameraFaceDetect';
import { FaSearch } from 'react-icons/fa';
import { flatMap } from 'lodash';
import ObjectDetection from './detect'

interface PropsFromState {
    //courseId:string
    videoStart:boolean
    user: IUser
    wrongAnswer:boolean
    correctAnswer:boolean
    completeWatch:boolean
    userCourseData :any,
    isCompleteWatch:boolean
}
interface PropsFromDispatch {
    start:any,
    stop:any,
    askTrainer:any
    resetPlay:any
    resetAnswer:any
    setAllowToPlay:any
    updatePhotoFile:any
}

interface IState {
    playDuration:number
    sendingToServer:boolean
    isIdentical:boolean
    confidence:number
    user:any
    playerControlStatus:string
    eyeCloseDetected: number
    modalUserGuidesTips: boolean,
    identicationState : number,  // 0: Idle ; 1 : Failed, 2: Warning ; 3: Processing : 9: Success
    identicationMsg : string,
    imageSrcBlob?:string,
    serverVerify:boolean,
    retryCount : number
}

type AllProps = PropsFromState & PropsFromDispatch

class PlayerControl extends React.Component<AllProps,IState> {
    ssdModel:any;
    blobUtil:BlobUtil;
    faceUtil:FaceUtil;
    interval:any;
    canvasRef:any;
    //screenshotRef:any;
    //livepreviewRef:any;
    stream:any;
    cameraOn:boolean;
    OnFocus:boolean;
    faceImgSrc:any;

    constructor(props:AllProps){
        super(props)
        this.state ={
            playDuration:0,
            sendingToServer:false,
            isIdentical:false,
            confidence:0,
            user:this.props.user,
            playerControlStatus:"stop",
            eyeCloseDetected :0,
            modalUserGuidesTips: false,
            identicationState : 0, 
            identicationMsg : '',
            serverVerify : false,
            retryCount : 1
        }
        this.blobUtil = new BlobUtil();
        this.faceUtil = new FaceUtil();
        this.faceUtil.setUser(this.props.user);

        this.cameraOn = false;
        this.OnFocus = true;
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleModalUserGuidesTips = this.handleModalUserGuidesTips.bind(this);
        this.UploadFacePhoto = this.UploadFacePhoto.bind(this);
        this.processImage = this.processImage.bind(this);
        this.handleOpenSlides = this.handleOpenSlides.bind(this);
        this.handleOpenFAQ = this.handleOpenFAQ.bind(this);
    }


    public componentDidMount() {
       
        const constraints = {
            video: true
        };
        //const video:any = document.getElementById('livepreview');
        
        // Test for permission
        navigator.mediaDevices.getUserMedia(constraints)
        .then((_stream) => {
             this.cameraOn = true;
             this.stream =_stream; 
             //video.srcObject = this.stream; 
            }, (error) =>{
                this.setState({
                    identicationState : 1, identicationMsg: "Camera blocked. Please allow camera access."
                });
            }
        ).catch(function(err) {
            /* handle the error */
            console.log("Camera failed! Error :" + err);
        });
        
        window.addEventListener("blur", this.handleOnBlur);
        window.addEventListener("focus", this.handleOnFocus);
    }
    
    componentWillUnmount(){
        try {
            this.stream.getTracks().forEach(function(track:any) {
                track.stop();
              });

              
        window.removeEventListener('blur', this.handleOnBlur);
        window.removeEventListener('focus', this.handleOnFocus);
            
        } catch (error) {
            console.log(error);
        }
    } 
    
    async componentDidUpdate(prevProps:AllProps) {
        // console.log("componentDidUpdate");
        if (prevProps.videoStart === false && this.props.videoStart === true){
            //console.log(prevProps);
            this.OnFocus = true; // Reset
            //console.log("Video Started:" + this.props.videoStart);
            //this.interval = setInterval(this.FaceMonitoring.bind(this) , 1000);
            this.setState({playerControlStatus:"start", sendingToServer:true, eyeCloseDetected : 0});
        }
        if (prevProps.videoStart === true && this.props.videoStart === false){
            //console.log("Video Stopped:" + this.props.videoStart);
            //clearInterval(this.interval);
            this.setState({playerControlStatus:"stop", sendingToServer:false, eyeCloseDetected : 0});
            this.props.stop();
        }
        if (prevProps.wrongAnswer === false && this.props.wrongAnswer === true){
            // Choose wrong answer, server verify again, else if rewind, allowtoplay to true, user can condinue play
            this.setState({serverVerify:false}, () => {
                this.props.stop();
                this.props.setAllowToPlay(false);
                this.props.resetAnswer();
            }); 
        }
        if (prevProps.correctAnswer === false && this.props.correctAnswer === true){
           // Capture Photo with TimeStamps, Upload to Blob and Update User Course Record
           //console.log("ANSWER CORRECT! Process Upload Photo");
           this.UploadFacePhoto();
           this.props.resetAnswer();
        }

        if (prevProps.completeWatch === false && this.props.completeWatch === true){
            // Capture Photo with TimeStamps, Upload to Blob and Update User Course Record
            //console.log("COMPLETED WATCH! Process Upload Photo");
            this.UploadFacePhoto();
         }
    }

    async UploadFacePhoto() {
        //if(this.state.imageSrcBlob != null){
        if (this.faceImgSrc != ""){
            var n = new Date();
            let blobRequestUrl:string ="";
            let filename = "Course_"+ this.replaceAll(n.toISOString(), ":", "") +".jpg";
            let imgBlob = await this.processImage(this.canvasRef, this.faceImgSrc);
            blobRequestUrl = await this.blobUtil.UploadBlob(filename, imgBlob ,"image/jpg",{resourceType:"UserCourse"});
            //console.log("UPLOAD FACE PHOTO SUCCESS : Face Photo URL : " + blobRequestUrl);

            this.props.updatePhotoFile(filename);
         }else{
            //console.log("UPLOAD FACE PHOTO FAILED : No Face Image to Upload!");
         }
    }

    processImage(canvas: any, imgSrc: any) {
        return new Promise(function (resolve, reject) {
            canvas.width = 600;
            canvas.height = 480;
            var ctx = canvas.getContext('2d');

            var image = new Image();
            image.src = imgSrc;
            image.onload = function() {
                ctx.drawImage(image, 0, 0, 600, 480);
                
                // var image = new Image();
                // image.src = imgSrc;
                // ctx.drawImage(image, 0, 0);
                
                // Add Timestamp
                var timestamp = new Date();
                //var options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: "2-digit", minute: "2-digit" };
                var options = { year: 'numeric', month: 'short', day: 'numeric', hour: "2-digit", minute: "2-digit" } as const;
                let timestampFormatted = timestamp.toLocaleTimeString("en-US", options);
                let font ="11px Arial"
                ctx.font = font;      
                ctx.textBaseline = 'top';
                ctx.fillStyle = '#3a3a3c';
                // get width of text
                var width = ctx.measureText(timestampFormatted).width;

                /// draw background rect assuming height of font
                ctx.fillRect(6, 6, width + 5, parseInt(font, 10) + 5);

                // text color
                ctx.fillStyle = '#fff';
                                
                ctx.fillText(timestampFormatted, 8, 8);
            
                canvas.toBlob(
                    function (blob: any) {
                        //setTimeout(() => { resolve(blob); }, 5000);
                        resolve(blob);
                    }
                );
            };
        });
    }

    handleOnBlur() {
        // Do something generic, if you have to
        //console.log("Windows on Blur!");
        this.OnFocus = false;
        //console.log("Camera : " + this.cameraOn + "; Focus:" + this.OnFocus);
    }
    handleOnFocus() {
        // Do something generic, if you have to
        //console.log("Windows on Blur!");
        this.OnFocus = true;
        //console.log("Camera : " + this.cameraOn + "; Focus:" + this.OnFocus);
    }
    
    FaceMonitoring() {
        this.setState({
            playDuration: this.state.playDuration + 1   
        });
        if(this.state.sendingToServer === true){
            this.setState({
                sendingToServer: false   
                },this.FaceMonitoringStart.bind(this));
                    
        }
    }
    FaceMonitoringStart(){
        this.FaceDetectionAndVerification()
            .then(
                this.FaceSend.bind(this),
                this.FaceSendError.bind(this)
        ).catch(this.FaceSendError.bind(this));
    }
    
    FaceSend(){
        this.setState({
            sendingToServer: true   
        });
    }
    FaceSendError(){
        this.setState({
            sendingToServer: true   
        });
    }
    replaceAll(target:string, search:string, replacement:string) {
        return target.replace(new RegExp(search, 'g'), replacement);
    };

    calculateDistance = (p: number[], q: number[]) => {
        if (p.length != q.length) return -1;
        const subtracted = q.map((i, n) => i - p[n]);
        const powered = subtracted.map(e => Math.pow(e, 2));
        const sum = powered.reduce((total, current) => total + current, 0)
        return Math.sqrt(sum);
    }

    async FaceDetectionAndVerification(){
        //console.log("FaceDetection & Verification")
        // When entered here should have image, check onFocus on camera
        // // Stop if camera undetected
        // if (!this.cameraOn || !this.OnFocus){
        //     clearInterval(this.interval);
        //     this.props.stop();
        //     this.setState({
        //         isIdentical:false,
        //         confidence:-1, 
        //         playerControlStatus:"stop",
        //         identicationState : 1, identicationMsg: "Camera undetected"
        //     });
        // }

        let matchResult ={isIdentical:false,confidence:0};
        //let retryCount = 0;

        // No need to do try as same image
        //do {
        try {
            //console.log("Detection : " + (retryCount + 1) + "...");
            // Add checking if user still exists
            //console.log(this.state.user);
            //console.log(this.props.user);
            if (this.state.user == undefined)
            { 
                //let currentUser = localStorage.getItem("CurrentUser");
                //this.state.user = JSON.parse(currentUser);
                 this.setState({
                     identicationState : 1, identicationMsg: "Error. Please select course again!"
                 });
                 this.props.stop();
                 this.props.setAllowToPlay(false);
                 return;
                //  alert("Please select course again");
                //  return <Redirect to="/" />
            } else {
                //localStorage.setItem(JSON.stringify(this.state.user), "CurrentUser");
            }
            
            var n = new Date();
            let blobRequestUrl:string ="";
            if(this.state.imageSrcBlob != null){
                let filename2 = "Player_"+ this.replaceAll(n.toISOString(), ":", "") +".jpg";
                let res = await fetch(this.state.imageSrcBlob);
                let blob2 = await res.blob();
                blobRequestUrl = await this.blobUtil.UploadBlob(filename2,blob2,"image/jpg",{resourceType:"ProtoType"});
            }

            // // Old version,capture from live preview
            // //let blob = await this.captureImage(this.livepreviewRef,this.canvasRef,this.screenshotRef);
            // let filename = "Player_"+ this.replaceAll(n.toISOString(), ":", "") +".png";
            // let blobRequestUrl2 = await this.blobUtil.UploadBlob(filename,"","image/png",{resourceType:"WatchVideo"});
    
            let faceIds:any = await this.faceUtil.DetectFace(blobRequestUrl);
            
            if(faceIds.length > 0){ // Handle for multiple faces in the photo
                console.log(faceIds.length + " face(s) detected ...");
                for (let faceIndex = 0; faceIndex < faceIds.length; faceIndex++) { // Verify Face in the set of Faces detected
                    const faceId = faceIds[faceIndex].faceId;
                    let verifyFaceResult = await this.faceUtil.VerifyFace(this.state.user.personId,faceId);
                    console.log(verifyFaceResult);
                    if(verifyFaceResult.isIdentical && verifyFaceResult.confidence > 0.7){
                        matchResult.isIdentical = true;
                        matchResult.confidence = verifyFaceResult.confidence;
                        //console.log("Face detected is identical");
                        break;
                    }
                    else {
                        //console.log("Face detected is not identical");
                        matchResult.confidence = verifyFaceResult.confidence;
                        
                        this.setState({
                           identicationState : 1, identicationMsg: "No identical face detected"
                        });
                    }
                }
            }else{
                //console.log("No Face detected!");
                this.setState({
                    identicationState : 1, identicationMsg: "No face detected"
                });
            }

            //retryCount ++;
            await this.dummyPause(2000); // Wait for 2 second to try again

        } catch (error) {
            console.log(error);
            this.setState({
                identicationState : 1, identicationMsg: "Face recognition failed!"
            });
        }
        //} while (retryCount < 3 && matchResult.isIdentical === false); // Retry to 3 times

        // console.groupEnd();

        if(matchResult.confidence == 0){
            clearInterval(this.interval);
            this.props.stop();
            this.setState({
                serverVerify:false, 
                isIdentical:matchResult.isIdentical,
                confidence:matchResult.confidence, 
                playerControlStatus:"stop",
                identicationState : 1, identicationMsg: "No Face Detected"
            });
        } else if(matchResult.confidence < 0.7){ // Stop of Confidence level less than 70%
            clearInterval(this.interval);
            this.props.stop();
            this.setState({
                serverVerify:false, 
                isIdentical:matchResult.isIdentical,
                confidence:matchResult.confidence, 
                playerControlStatus:"stop",
                identicationState : 1, identicationMsg: "Matching rate is too low (" + (matchResult.confidence*100).toFixed(2) + "%)"
            });
        }
        else
        {
            let msg = "";
            let iState = 0;
            if (matchResult.confidence > 0.8){
                msg = "High matching rate (" + (matchResult.confidence*100).toFixed(2) + "%)"
                iState = 9;
            }else{
                msg = "Low matching rate (" + (matchResult.confidence*100).toFixed(2) + "%). Please move to brighter desk."
                iState = 2;
            }

            // Continue Plays
            if(this.state.playerControlStatus === "start"){
                //this.props.start();
            }
            this.setState(
            {
                retryCount: 1, // Reset retry
                isIdentical:matchResult.isIdentical,
                confidence:matchResult.confidence,
                playerControlStatus:"playing",
                identicationState : iState, identicationMsg: msg
            });
            this.props.setAllowToPlay(true);
                
        }
    }

    dummyPause(interval:number){
        return new Promise(function(resolve, reject) {
            setTimeout(() => { resolve(); }, interval);
        });
    }

    /*
    start(e:any){
        e.preventDefault();
        this.interval = setInterval(this.FaceMonitoring.bind(this) , 1000);
        //this.props.start();
        this.setState({playerControlStatus:"start", sendingToServer:true });
    }

    stop(e:any){
        e.preventDefault();
        clearInterval(this.interval);
        this.setState({playerControlStatus:"stop"});
        this.props.stop();
    }
    */

    captureImage(video:any,canvas:any,img:any) {
        return new Promise(function(resolve, reject) {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            canvas.getContext('2d').drawImage(video, 0, 0);
            img.src = canvas.toDataURL('image/png');
            
            canvas.toBlob(
                function(blob:any){
                    //setTimeout(() => { resolve(blob); }, 5000);
                    resolve(blob);
                }
            );
        });
    }

    handleModalUserGuidesTips(){
        this.setState({modalUserGuidesTips : !this.state.modalUserGuidesTips});
    }

    async handleOpenSlides(){
        let courseRecId = this.props.userCourseData?.courseRecId;
        if (courseRecId){
            let blobRequestUrl = await new BlobUtil().GetCoursesBlob("slide.pdf", "courses/" + courseRecId);
            window.open(blobRequestUrl, "_blank");
        } else{
            alert('Please contact support to download files.')
        }
    }
    async handleOpenFAQ(){
        let courseRecId = this.props.userCourseData?.courseRecId;
        if (courseRecId){
            let blobRequestUrl = await new BlobUtil().GetCoursesBlob("trainer.pdf", "courses/" + courseRecId);
            window.open(blobRequestUrl, "_blank");} 
        else{
            alert('Please contact support to download files.')
       }
    }

    //serverVerify:boolean =false;
    private async FaceDetectStatus(found:boolean, imageSrc:string, msg:string){
        //this.props.setAllowToPlay(true);

        if(!this.OnFocus){
            if (this.state.identicationState !== 1){
                // Not focus reset state
                this.setState({
                    serverVerify : false, identicationState : 1, identicationMsg: "Not in focus"
                }, () => {
                    this.props.stop();
                    this.props.setAllowToPlay(false);
                });
                return;
            }
        }
        else{
            if(found === true)
            {
                this.faceImgSrc = imageSrc;

                // console.log("FaceDetectStatus : found" );
                if(this.state.serverVerify === false){
                    //console.log("FaceDetectStatus : serverVerify : false" );
                    //if(this.state.sendingToServer === true){
                        if(imageSrc != null){
                            // console.log("FaceDetectStatus : img " + imageSrc );
                            //console.log("FaceDetectStatus : img " + imageSrc);
                            this.setState({
                                retryCount : this.state.retryCount + 1,
                                serverVerify : true,
                                sendingToServer: true,
                                imageSrcBlob:imageSrc,
                                identicationState : 3, identicationMsg: "Processing face recognition. (" + this.state.retryCount + ")"
                                }, this.FaceMonitoring);
                        }
                    //}
                } else {
                    //console.log("FaceDetectStatus : serverVerify : true" );
                    // Do nothing. Send to process
                }
            }
            else
            {
                //console.log("FaceDetectStatus : not found" );
                if(this.state.serverVerify === true){
                    this.setState({
                        retryCount:1, 
                        serverVerify : false, 
                        identicationState : 1, 
                        identicationMsg: (msg)? msg: "No face detected. Please focus in camera."
                    }, ()=>{
                        this.props.stop();
                        this.props.setAllowToPlay(false);
                    });
                } else{
                    // Do nothing. Remain failed
                }

            }
        }
    }
    
    renderCourseSection(){
        
        //const courseId = this.props.courseId;
        //const sectionId = this.props.sectionId;
        let sectionList:string[] = [
           // "Course Overview"
            // , "Core Decisions",
            // "Objective",
            // "Method 1",
            // "Method 2",
            // "Summary"
        ]
        
        return (
            <div className="row">
                <canvas ref={(input) => { this.canvasRef = input; }} style={{ display: "none" }}></canvas>
                <div className="col-sm-12">
                    <ul className="list-group mt-3">
                        {
                            /*sectionList.map(
                                (section , index) =>{
                                    return <Link key={index}  to={'/Course/Play/'+ courseId + "/" +(index+1) } className={Number(sectionId) === (index+1) ? "list-group-item active" :"list-group-item "}>{section}</Link>
                                }
                            )*/
                        }
                    </ul>
                </div>
                <div className="col-sm-12">
                    <ul className="list-group mt-3">
                        {
                           (this.props.userCourseData?.verificationType == "noVerification") && 
                           <div>
                                <img width='36px' src='data:image/svg+xml;base64,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' />
                                <span>No Verification</span>
                           </div>
                        }
                        {
                           (this.props.userCourseData?.verificationType != "noVerification") && 
                           <div>
                                <img width='36px' src='data:image/svg+xml;base64,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' />    
                                <span>Verification</span>
                           </div>
                        }
                        <span className="list-group-item" onClick={this.handleModalUserGuidesTips} style={{cursor: "pointer"}}>User Guides/Tips</span>
                        <a className="list-group-item" onClick={this.handleOpenSlides}>Download Slides</a>
                        <a className="list-group-item" onClick={this.handleOpenFAQ}>Download FAQs</a>
                        <Button color="warning" onClick={this.props.askTrainer}>Ask Trainer</Button>
                        <br/>
                        {
                            this.props.userCourseData?.courseRecId != "40671b45-2e7a-d90f-8f34-563a1d851e8b" &&
                            <Button color="danger" onClick={this.props.resetPlay}>Reset</Button>
                        }
                    </ul>
                </div>
                <Modal size="lg" isOpen={this.state.modalUserGuidesTips} unmountOnClose={true}>
                    <ModalHeader toggle={this.handleModalUserGuidesTips}>User Guides / Tips</ModalHeader>
                    <ModalBody>
                        <Label>On Camera</Label>
                        <ol>
                            <li>The camera will detect your face every 5 minutes while you attend the course</li>
                            <li>The course will pause if face is unable to recognized</li>
                            <li>Use soft lighting from the front, avoid over exposure.</li>
                            <li>Cleanliness of the camera is vital for a clear shot</li>
                            <li>Camera detection within 0.5m to 1m</li>
                        </ol>
                        <Label>On Video</Label>
                        <ol>
                            <li>Each user account can only play a single video at a time</li>
                            <li>Videos are not allowed to fast forward</li>
                            <li>Video will pause if face is unable to be recognized, user only can continue from last verified face video play time.</li>
                            <li>When course is paused by yourself, you can continue to play from the part where the video is paused.</li>
                            <li>There will be a Concentration Test Question popup within 15 minutes, (with 2 seconds of picture). If you able to answer, the video will be continued. If you are unable to answer, the video will replay again from the last frame. </li>
                        </ol>
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="primary" onClick={this.handleSendAskTrainer}>Send</Button>{' '} */}
                        <Button color="secondary" onClick={this.handleModalUserGuidesTips}>Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );

    }
    render(){
        const state = () => {
            if (this.props.isCompleteWatch){
                return <Badge color="success" pill>&nbsp;<i className="fas fa-check mr-1"></i>&nbsp;Completed Watch&nbsp;</Badge>;
            } else {
                switch(this.state.identicationState) {
                    case 0: return <Badge color="secondary" pill>&nbsp;<i className="fas fa-stop-circle mr-1"></i>&nbsp;Idle&nbsp;</Badge>;
                    case 1: return <Badge color="danger" pill>&nbsp;<i className="fas fa-exclamation-circle mr-1"></i>&nbsp;Failed&nbsp;</Badge>;
                    case 2: return <Badge color="warning" pill>&nbsp;<i className="fas fa-exclamation-triangle mr-1"></i>&nbsp;Warning&nbsp;</Badge>;
                    case 3: return <Badge color="primary" pill>&nbsp;<i className="fas fa-angle-double-right mr-1"></i>&nbsp;Processing&nbsp;</Badge>;
                    case 9: return <Badge color="success" pill>&nbsp;<i className="fas fa-check mr-1"></i>&nbsp;Good&nbsp;</Badge>;
                }
            }
          }
        //const courseId = this.props.courseId;
        return (
            <Container>
                <div className="row">
                    <div className="col-12">
                        <CameraFaceDetect faceDetectStatus={this.FaceDetectStatus.bind(this)} />
                        {/* <ObjectDetection faceDetectStatus={this.FaceDetectStatus.bind(this)} /> */}
                        {/* <canvas ref={(input) => { this.canvasRef = input; }} style={{display:"none"}}></canvas>
                        <img ref={(input) => { this.screenshotRef = input; }} style={{display:"none"}} id="screenshot" alt="" /> */}
                    </div>
                </div><div className="row" style={{height:"30px"}}>
                    <div className="col-12">
                        <div className="ml-1">
                            {state()}
                            {
                                (!this.props.isCompleteWatch && !this.state.sendingToServer && this.state.identicationState === 3) && (<Loader />)
                            }
                        </div>
                    </div>
                </div>
                {
                    !this.props.isCompleteWatch && 
                    <div className="row" style={{height:"50px"}}>
                        <div className="col-12">
                            <div className="ml-1">
                            {this.state.identicationMsg}<br/>
                            </div>
                        </div>
                    </div>
                }
                
                {this.renderCourseSection()}
            </Container>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    //user: state.userReducer
    user: state.userInfo.byId[0]
})

const mapDispatchToProps = {
    
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayerControl)
